module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921005649_T.c7b776b6.jpg";